module.exports = __webpack_public_path__ + "static/media/howItWorks.044f35ec.png";